"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const SearchIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 22 22"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.gray,
  d: "M22.427 24.427a8.5 8.5 0 112-2l5.585 5.585c.55.55.546 1.43 0 1.976l-.024.024a1.399 1.399 0 01-1.976 0l-5.585-5.585zM17.5 24a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
  transform: "translate(-177 -9) translate(168)"
}));

var _default = SearchIcon;
exports.default = _default;